export default __webpack_public_path__ + "static/media/3.dbe1f28d.png";